var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1010105262",
    filter: "url(#filter0_d_509_4059)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 3",
    cx: 27.9831,
    cy: 23,
    rx: 23.9831,
    ry: 23,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1010105181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8898 28.6072L9.64453 31.1016H14.1029L15.3636 28.6072H10.8898ZM15.3636 28.5754H19.8219L21.0518 26.081H16.6857L17.9309 23.5706H13.4726L12.2119 26.081H16.5934L15.3636 28.5754ZM26.0636 16.0396H21.7436L20.5137 18.55H24.7107L23.4654 21.0603H19.2531L20.5137 18.55H16.04L14.7947 21.0603H19.1762L17.9309 23.5706H22.3124L21.0518 26.081H25.2642L23.7883 29.0838L17.7157 31.0857L23.0965 31.0698L23.1119 31.0222C23.1529 31.0116 23.1785 30.9904 23.1887 30.9587L31.6289 13.7994C31.6289 13.7888 31.6289 13.7782 31.6289 13.7676L31.7519 13.5293H27.2935L26.0636 16.0396ZM26.202 16.0396H30.2145L28.9692 18.55H24.9721L26.202 16.0396ZM22.3893 23.5706L23.6346 21.0603H27.7394L26.4941 23.5706H22.3893ZM38.8238 25.652L38.8391 25.6361L42.99 22.6332L31.8134 26.4623L29.5073 31.1016L31.3521 31.1175L38.7469 25.7155V25.6996L38.8238 25.652ZM37.9013 25.5408L36.902 25.366L38.916 24.4762L39.5924 24.6034L37.9013 25.5408ZM36.6561 26.2557L33.3815 28.0988L31.5213 27.7492L35.3186 26.0651L36.6561 26.2557Z",
    fill: "#FCB61A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.1908 26.5376L33.604 29.8453L33.7439 31.1175C33.7542 31.1175 34.2466 31.1175 35.221 31.1175C36.1954 31.1175 36.8225 31.1175 37.1024 31.1175C37.631 31.0963 38.17 31.0963 38.7194 31.1175C38.7505 31.1175 38.7764 31.1175 38.7971 31.1175L38.1908 26.5376ZM42.42 13.9746C42.0675 13.8049 41.7047 13.6777 41.3316 13.5929L40.8651 13.5293H31.8625L22.9844 31.1175H28.0376L30.9452 25.2813L42.5132 22.5301C42.9175 22.1803 43.2648 21.8251 43.555 21.4647C43.8765 21.0618 44.1252 20.6483 44.3015 20.2243C44.4773 19.8214 44.5968 19.392 44.6589 18.9362V17.4572C44.6279 17.1816 44.5759 16.9007 44.5035 16.6144C44.3272 15.8829 44.011 15.2733 43.555 14.7856C43.244 14.4675 42.8657 14.1972 42.42 13.9746ZM36.7137 17.3618H40.3209L37.3201 19.3973L37.8798 23.1503L35.1899 20.749L31.9558 23.0549L33.8683 19.1906L31.9558 17.3618H34.7545L36.0451 14.8969L36.7137 17.3618Z",
    fill: "#663399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_509_4059",
    x: 0,
    y: 0,
    width: 55.9658,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.856883 0 0 0 0 0.721757 0 0 0 0 0.992008 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_509_4059"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_509_4059",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRr);
export default __webpack_public_path__ + "static/media/rr.97c1073d720a3e312e01ecbba68643c6.svg";
export { ForwardRef as ReactComponent };